import Request from "../common/request";

//请求方法的封装
export const innovationNeedsList = data =>
  Request.get("/innovationNeeds/home/count", data);

// 创新需求form
export const innovationneeds = data =>
  Request.post("/innovationNeeds/innovationneeds/save", data);



// WEBPACK FOOTER //
// ./src/api/common.js